export interface Bonus {
  number: string
  title: string
  tagline: string
  bullets: string[]
  value: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Mapa Rápido de Decisión',
    tagline:
      'Elegí la sesión correcta en menos de 5 minutos según el estado del grupo, el clima y el objetivo técnico.',
    bullets: [
      'Checklist de decisión rápida',
      'Adaptación según fatiga del grupo',
      'Matriz por día de la semana',
    ],
    value: '$27',
    image:
      'https://cdn.magicpatterns.com/uploads/mhfeB5jWoqxbEXyVXhSpvb/mockup-mapa-rapido-de-decision.webp',
    alt: 'Portada del Bono 1: Mapa rápido de decisión, con un entrenador y su grupo en la pista.',
  },
  {
    number: '2',
    title: 'Manual de Correcciones Express',
    tagline:
      'Detectá 40 errores técnicos comunes y corregilos con frases cortas que tus atletas entienden al instante.',
    bullets: [
      '40 errores por disciplina',
      'Consignas verbales listas',
      'Ejercicios de corrección rápida',
    ],
    value: '$27',
    image:
      'https://cdn.magicpatterns.com/uploads/522sEoGZQ7TtrqugtuYZZR/mockup-manual-de-correcciones-express.webp',
    alt: 'Portada del Bono 2: Manual de correcciones express, con un velocista en plena aceleración.',
  },
  {
    number: '3',
    title: 'Guía de Adaptación para Grupos Mixtos',
    tagline:
      'Convertí una sesión de un solo nivel en una sesión usable para principiantes, intermedios y avanzados juntos.',
    bullets: [
      'Sistema de 3 niveles (Base / Desarrollo / Rendimiento)',
      'Adaptación de distancia y volumen',
      'Organización de pista sin caos',
    ],
    value: '$27',
    image:
      'https://cdn.magicpatterns.com/uploads/oxhPhwZWHbFFNWfK4w7JnS/mockup-guia-de-adaptacion-para-grupos-mixtos.webp',
    alt: 'Portada del Bono 3: Guía de adaptación para grupos mixtos, con conos sobre la pista al atardecer.',
  },
  {
    number: '4',
    title: 'Protocolos de Calentamiento Específico',
    tagline:
      'Calentamientos diseñados para cada disciplina: velocidad, vallas, fondo, saltos, lanzamientos y marcha.',
    bullets: [
      '8 protocolos por disciplina',
      'Versión corta (10 min) y completa',
      'Activaciones nerviosas específicas',
    ],
    value: '$19',
    image:
      'https://cdn.magicpatterns.com/uploads/wFPhzwD4eSwRxek42u9XB7/mockup-protocolos-de-calentamiento-especifico.webp',
    alt: 'Portada del Bono 4: Protocolos de calentamiento específico, con un atleta en posición de arranque.',
  },
  {
    number: '5',
    title: 'Biblioteca de Consignas Técnicas',
    tagline:
      '50+ “cues” verbales para sonar como un entrenador profesional y lograr cambios mecánicos inmediatos.',
    bullets: [
      'Consignas por disciplina',
      'Frases para ordenar grupos',
      'Versión imprimible de bolsillo',
    ],
    value: '$19',
    image:
      'https://cdn.magicpatterns.com/uploads/27aTBmcr4fu2Tx512q3aXb/mockup-biblioteca-de-consignas-tecnicas.webp',
    alt: 'Portada del Bono 5: Biblioteca de consignas técnicas, con tacos de salida sobre la pista.',
  },
]

/** Resumen corto usado en la tabla de valor. */
export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bono 1 — Mapa de Decisión', value: '$27' },
  { label: 'Bono 2 — Correcciones Express', value: '$27' },
  { label: 'Bono 3 — Adaptación Grupos Mixtos', value: '$27' },
  { label: 'Bono 4 — Calentamientos Específicos', value: '$19' },
  { label: 'Bono 5 — Consignas Técnicas', value: '$19' },
]
